import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";

import {DocumentUtils} from "../../Utils/DocumentUtils";

import {useContextBuilder} from "../../Hooks/ContextBuilderHooks";
import {useToolBuilder, useTools} from "../../Hooks/ToolBuilderHooks";

export const StreamBankToolRouter = props => {
    const [hasSession, setHasSession] = useState(true);
    const [toolContext, setToolContext] = useState();
    const displayTimeout = useSelector(state => state.loginState.displayTimeout);
    const breadcrumbs = useSelector(state => state.contextState.breadcrumbs);

    const {params} = props.match;
    const {tool, pProgId, cProgId, projId, conActId, sampleEventId} = params;

    const contextBuilder = useContextBuilder(props);
    const toolBuilder = useToolBuilder(props);
    const tools = useTools(props);

    useEffect(() => {
        if (displayTimeout) {
            if (hasSession) {
                setHasSession(false);
            }
        } else {
            if (!hasSession) {
                setHasSession(true);
            }
        }
    }, [displayTimeout]);

    useEffect(() => {
        if(hasSession) {
            contextBuilder();
            const toolContext = toolBuilder();
            setToolContext(toolContext);
        }
    }, [tool, pProgId, cProgId, projId, conActId, sampleEventId, props.AvailableTools]);

    useEffect(() => {
        if(toolContext?.isValid) {
            if(!toolContext.component) {
                const tool = tools.find((x) => x.isDefault);
                const url = window.location.pathname;

                let segments = url.split("/");
                segments.splice(-1,1);

                DocumentUtils.changePage(segments.join("/") + "/" + tool.key);
            }
        }
    }, [toolContext]);

    if(toolContext && toolContext.isValid) {
        if(toolContext.component) {
            //Setup page title
            const tool = tools?.find(x => x.key == toolContext?.key);
            const node = breadcrumbs?.slice(-1)?.[0];
            if (node && tool) {
                const nodeShortTitle = node.shortTitle != null ? node.shortTitle : node.title;
                DocumentUtils.SetTitle(nodeShortTitle + " - " + tool.title + " - StreamBank®");
            } else if (tool) {
                DocumentUtils.SetTitle(tool.title + " - StreamBank®");
            }

            //render tool
            return <toolContext.component {...props} />;
        }
    }

    return null;
};


